//# sourceMappingURL=user.mjs.map
/// <reference types="./user.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $user_id from "../data/auth/user_id.mjs";
import * as $notif_preferences from "../data/notif_preferences.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, Empty as $Empty, CustomType as $CustomType, isEqual } from "../gleam.mjs";

export class Role extends $CustomType {
  constructor(id, name) {
    super();
    this.id = id;
    this.name = name;
  }
}
export const Role$Role = (id, name) => new Role(id, name);
export const Role$isRole = (value) => value instanceof Role;
export const Role$Role$id = (value) => value.id;
export const Role$Role$0 = (value) => value.id;
export const Role$Role$name = (value) => value.name;
export const Role$Role$1 = (value) => value.name;

export class Engineering extends $CustomType {}
export const Function$Engineering = () => new Engineering();
export const Function$isEngineering = (value) => value instanceof Engineering;

export class Product extends $CustomType {}
export const Function$Product = () => new Product();
export const Function$isProduct = (value) => value instanceof Product;

export class Security extends $CustomType {}
export const Function$Security = () => new Security();
export const Function$isSecurity = (value) => value instanceof Security;

export class Sales extends $CustomType {}
export const Function$Sales = () => new Sales();
export const Function$isSales = (value) => value instanceof Sales;

export class Legal extends $CustomType {}
export const Function$Legal = () => new Legal();
export const Function$isLegal = (value) => value instanceof Legal;

export class Marketing extends $CustomType {}
export const Function$Marketing = () => new Marketing();
export const Function$isMarketing = (value) => value instanceof Marketing;

export class Other extends $CustomType {}
export const Function$Other = () => new Other();
export const Function$isOther = (value) => value instanceof Other;

export class User extends $CustomType {
  constructor(id, name, email, preferences, picture, initials, roles, inherited_roles, function$) {
    super();
    this.id = id;
    this.name = name;
    this.email = email;
    this.preferences = preferences;
    this.picture = picture;
    this.initials = initials;
    this.roles = roles;
    this.inherited_roles = inherited_roles;
    this.function = function$;
  }
}
export const User$User = (id, name, email, preferences, picture, initials, roles, inherited_roles, function$) =>
  new User(id,
  name,
  email,
  preferences,
  picture,
  initials,
  roles,
  inherited_roles,
  function$);
export const User$isUser = (value) => value instanceof User;
export const User$User$id = (value) => value.id;
export const User$User$0 = (value) => value.id;
export const User$User$name = (value) => value.name;
export const User$User$1 = (value) => value.name;
export const User$User$email = (value) => value.email;
export const User$User$2 = (value) => value.email;
export const User$User$preferences = (value) => value.preferences;
export const User$User$3 = (value) => value.preferences;
export const User$User$picture = (value) => value.picture;
export const User$User$4 = (value) => value.picture;
export const User$User$initials = (value) => value.initials;
export const User$User$5 = (value) => value.initials;
export const User$User$roles = (value) => value.roles;
export const User$User$6 = (value) => value.roles;
export const User$User$inherited_roles = (value) => value.inherited_roles;
export const User$User$7 = (value) => value.inherited_roles;
export const User$User$function = (value) => value.function;
export const User$User$8 = (value) => value.function;

function dotted_name(name) {
  let _pipe = name;
  let _pipe$1 = $string.first(_pipe);
  return $result.map(
    _pipe$1,
    (_capture) => { return $string.append(_capture, "."); },
  );
}

export function short_name(user) {
  let $ = $string.split(user.name, " ");
  if ($ instanceof $Empty) {
    return "";
  } else {
    let $1 = $.tail;
    if ($1 instanceof $Empty) {
      let one = $.head;
      return one;
    } else {
      let one = $.head;
      let rest = $1;
      let _pipe = rest;
      let _pipe$1 = $list.filter_map(_pipe, dotted_name);
      let _pipe$2 = $list.prepend(_pipe$1, one);
      return $string.join(_pipe$2, " ");
    }
  }
}

export function first_name(user) {
  let $ = $string.split(user.name, " ");
  if ($ instanceof $Empty) {
    return "";
  } else {
    let one = $.head;
    return one;
  }
}

export function function_to_string(function$) {
  if (function$ instanceof Engineering) {
    return "engineering";
  } else if (function$ instanceof Product) {
    return "product";
  } else if (function$ instanceof Security) {
    return "security";
  } else if (function$ instanceof Sales) {
    return "sales";
  } else if (function$ instanceof Legal) {
    return "legal";
  } else if (function$ instanceof Marketing) {
    return "marketing";
  } else {
    return "other";
  }
}

export function encode_function(function$) {
  let _pipe = function_to_string(function$);
  return $json.string(_pipe);
}

export function encode_roles(role) {
  return $json.object(
    toList([["id", $json.string(role.id)], ["name", $json.string(role.name)]]),
  );
}

export function encode(user) {
  return $json.object(
    toList([
      ["id", $user_id.encode(user.id)],
      ["email", $json.string(user.email)],
      ["name", $json.string(user.name)],
      ["picture", $json.nullable(user.picture, $json.string)],
      ["roles", $json.array(user.roles, encode_roles)],
      ["inherited_roles", $json.array(user.inherited_roles, encode_roles)],
      ["function", $json.nullable(user.function, encode_function)],
      [
        "preferences",
        $json.nullable(user.preferences, $notif_preferences.to_json),
      ],
    ]),
  );
}

function initials(name) {
  let _pipe = name;
  let _pipe$1 = $string.split(_pipe, " ");
  let _pipe$2 = $list.map(
    _pipe$1,
    (_capture) => { return $string.slice(_capture, 0, 1); },
  );
  let _pipe$3 = $list.map(_pipe$2, $string.capitalise);
  return $string.join(_pipe$3, "");
}

export function function_decoder() {
  return $decode.then$(
    $decode.string,
    (function$) => {
      if (function$ === "engineering") {
        return $decode.success(new Engineering());
      } else if (function$ === "product") {
        return $decode.success(new Product());
      } else if (function$ === "security") {
        return $decode.success(new Security());
      } else if (function$ === "sales") {
        return $decode.success(new Sales());
      } else if (function$ === "legal") {
        return $decode.success(new Legal());
      } else if (function$ === "marketing") {
        return $decode.success(new Marketing());
      } else if (function$ === "other") {
        return $decode.success(new Other());
      } else {
        return $decode.failure(new Other(), "Function");
      }
    },
  );
}

export function roles_decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "name",
        $decode.string,
        (name) => { return $decode.success(new Role(id, name)); },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $user_id.decoder(),
    (id) => {
      return $decode.field(
        "email",
        $decode.string,
        (email) => {
          return $decode.field(
            "name",
            $decode.string,
            (name) => {
              return $decrypt.optional_field(
                "picture",
                $decode.string,
                (picture) => {
                  return $decode.field(
                    "roles",
                    $decode.list(roles_decoder()),
                    (roles) => {
                      return $decode.optional_field(
                        "inherited_roles",
                        toList([]),
                        $decode.list(roles_decoder()),
                        (inherited_roles) => {
                          return $decode.field(
                            "function",
                            $decode.optional(function_decoder()),
                            (function$) => {
                              return $decode.field(
                                "preferences",
                                $decode.optional($notif_preferences.decoder()),
                                (preferences) => {
                                  let initials$1 = initials(name);
                                  let _pipe = new User(
                                    id,
                                    name,
                                    email,
                                    preferences,
                                    picture,
                                    initials$1,
                                    roles,
                                    inherited_roles,
                                    function$,
                                  );
                                  return $decode.success(_pipe);
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

/**
 * `function` as *stored*: an unrecognized value — a variant retired since the
 * row was written — reads as `None` rather than failing, so one stale row
 * cannot fail a batched read for every other row alongside it.
 *
 * Never use this on a request body: that path stays on `function_decoder`.
 */
export function stored_function_decoder() {
  return $decode.one_of(
    $decode.map(function_decoder(), (var0) => { return new Some(var0); }),
    toList([$decode.success(new None())]),
  );
}

export function is_admin(user) {
  let _pipe = user.roles;
  let _pipe$1 = $list.find(_pipe, (role) => { return role.name === "Admin"; });
  return $result.is_ok(_pipe$1);
}

export function is_super_admin(user) {
  let _pipe = user.roles;
  let _pipe$1 = $list.find(
    _pipe,
    (role) => { return role.name === "Super Admin"; },
  );
  return $result.is_ok(_pipe$1);
}

export function select(uids, users) {
  return $list.filter_map(
    uids,
    (uid) => {
      return $list.find(users, (user) => { return isEqual(user.id, uid); });
    },
  );
}

export function find(uid, users) {
  return $list.find(users, (user) => { return isEqual(user.id, uid); });
}
